import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

const ClosePricelistDialog = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation("close-pricelist-dialog");

  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "556px",
          mx: "5px",
          borderRadius: 4,
          boxShadow: "0px 4px 30px rgba(0, 0, 0, 0.08)",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2,
          borderBottom: "1px solid #EAEAEA",
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 500,
            fontSize: "18px",
            color: "#2F2B3DE5",
            p: 0,
          }}
        >
          {t("close_dialog")}
        </DialogTitle>
        <IconButton onClick={onClose}>
          <CloseIcon sx={{ fontSize: "20px" }} />
        </IconButton>
      </Box>

      {/* Body */}
      <DialogContent sx={{ p: 3 }}>
        <Typography
          sx={{
            mb: 1,
            fontSize: "16px",
            fontWeight: 500,
            color: "#2F2B3DE5",
          }}
        >
          {t("are_you_sure_leave")}
        </Typography>
        <Typography sx={{ fontSize: "14px", color: "#2F2B3D99" }}>
          {t("changes_not_saved")}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "space-between",
          gap: "10px",
          flexDirection: { xs: "column", sm: "row" },
          p: { xs: "16px", md: "24px" },
        }}
      >
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: "#808390",
            borderRadius: "8px",
            fontSize: "15px",
            fontWeight: 500,
            color: "white",
            textTransform: "capitalize",
            width: { xs: "100%", sm: "auto" },
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#808399",
              boxShadow: "none",
            },
          }}
        >
          {t("continue_editing")}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            backgroundColor: "#B7484A",
            borderRadius: "8px",
            fontSize: "15px",
            fontWeight: 500,
            color: "white",
            textTransform: "capitalize",
            boxShadow: "none",
            width: { xs: "100%", sm: "auto" },
            ml: "0px !important",
            "&:hover": {
              backgroundColor: "#9E3A3C",
              boxShadow: "none",
            },
          }}
        >
          {t("close_without_save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClosePricelistDialog;
